import { render, staticRenderFns } from "./AppointmentOnboardingView.vue?vue&type=template&id=60224df6&scoped=true&"
import script from "./AppointmentOnboardingView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentOnboardingView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentOnboardingView.vue?vue&type=style&index=0&id=60224df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60224df6",
  null
  
)

export default component.exports